module.exports = __webpack_public_path__ + "static/media/received_463086622899148.01655dba.jpeg";